// @ts-nocheck
/* Port of QuickSummaryChecklist.js (30L). BYTE-IDENTICAL. */
import React from 'react';
import { getCategoryMeta } from './releaseUtils';

const QuickSummaryChecklist = ({ highlights = [] }: any) => {
  if (!highlights.length) return null;
  const sorted = [...highlights].sort(
    (a: any, b: any) => (a.sort_order ?? 0) - (b.sort_order ?? 0),
  );
  return (
    <div className="rc-checklist">
      {sorted.map((h: any, i: number) => {
        const meta = getCategoryMeta(h.category);
        return (
          <div className="rc-check" key={h.id || i} title={meta.label}>
            <span
              className="rc-check__badge"
              style={{ background: meta.color }}
              aria-label={meta.label}
            >
              {meta.icon}
            </span>
            <span>{h.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default QuickSummaryChecklist;
